import React, {Fragment, useEffect, useState} from "react";
import 'react-medium-image-zoom/dist/styles.css'
import {ClipLoader} from "react-spinners";
import axios from "axios";
import {Document, Page} from 'react-pdf';
import 'react-pdf/dist/esm/Page/AnnotationLayer.css';

export default function ContainerFotoArchivio({
                                                  titolo,
                                                  sottotitolo,
                                                  endpointContent,
                                                  handleOnClick,
                                              }) {

    const [file, setFile] = useState(false);
    const [loadSpinner, setLoadSpinner] = useState(false);

    useEffect(() => {
        if (endpointContent) {
            setLoadSpinner(true);
            axios
                .get(endpointContent)
                .then((response) => {
                    setLoadSpinner(false);
                    setFile(response.data.data)
                });
        }
    }, [endpointContent]);

    function getImmagine() {
        if (file && file.content_type) {
            if (file.content_type.startsWith('image/') && file.content_type !== 'image/heic') {
                if (file.url && file.url !== '') {
                    return (
                        <img src={file.url}
                             className={"ns-foto-archivio-img"}/>
                    );
                } else {
                    return (
                        <img src={`data:${file.content_type};base64, ${file.contenuto}`}
                             className={"ns-foto-archivio-img"}/>
                    );
                }
            } else if (file.content_type.toLowerCase() === 'application/pdf') {
                if (file.contenuto === 'default') {
                    return (
                        <img src={"assets/img/logo_pdf.png"} className={"ns-foto-archivio-img"}/>
                    );
                } else {
                    return (
                        <div className={"ns-pdf-view-container table-responsive"}>
                            <Document file={`data:application/pdf;base64,${file.contenuto}`}>
                                <Page pageNumber={1}
                                      renderTextLayer={false}
                                      className="ns-foto-archivio-img"
                                      height={'160'}
                                      style={{
                                          backgroundColor: 'unset',
                                          objectPosition: 'center',
                                          textAlign: 'center',
                                      }}/>
                            </Document>
                        </div>
                    );
                }
            }
        }
        return (
            <img src={`assets/img/no-foto.jpg`}
                 className={"ns-foto-archivio-img"}/>
        );
    }

    return (
        <Fragment>
            <div
                className={"ns-container-foto-upl"}
                onClick={(event) => {
                    handleOnClick(event);
                }}
            >
                <div className={"ns-container-foto-archivio-label text-center ns-cursor-pointer ns-hover-shadow"}>
                    <div style={{
                        height: "66px"
                    }}>
                        <h6>{titolo.length > 35 ? `${titolo.substring(0, 35)}...` : titolo}</h6>
                        <p style={{
                            fontSize: "0.8rem"
                        }}>{sottotitolo || ''}</p>
                    </div>
                    <div className={"ns-foto-archivio-container"}>
                        {
                            loadSpinner === true ?
                                <ClipLoader
                                    color={'#355d98'}
                                    loading={loadSpinner}
                                    size={80}/>
                                :
                                <div className={"ns-foto-archivio"}>
                                    {
                                        getImmagine()
                                    }
                                </div>
                        }
                    </div>
                </div>
            </div>
        </Fragment>
    )
}
